import { useId } from "react";

type Props = {
  startColor: string;
  endColor: string;
};

export default function IconTemplates({ startColor, endColor }: Props) {
  const gradientId = useId();

  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8333 20.583H5.41667C4.84203 20.583 4.29093 20.3547 3.8846 19.9484C3.47827 19.5421 3.25 18.991 3.25 18.4163V6.49967C3.25 5.92504 3.47827 5.37394 3.8846 4.96761C4.29093 4.56128 4.84203 4.33301 5.41667 4.33301H9.75L13 7.58301H20.5833C21.158 7.58301 21.7091 7.81128 22.1154 8.21761C22.5217 8.62394 22.75 9.17504 22.75 9.74967V12.458M19.2833 22.5514L16.9303 23.7843C16.8605 23.8206 16.782 23.8368 16.7034 23.8311C16.6249 23.8254 16.5495 23.798 16.4857 23.7519C16.4219 23.7058 16.3721 23.6429 16.342 23.5702C16.3118 23.4975 16.3025 23.4178 16.315 23.3401L16.7646 20.7282L14.8612 18.8789C14.8044 18.824 14.7641 18.7542 14.7451 18.6775C14.726 18.6008 14.7289 18.5203 14.7534 18.4452C14.778 18.3701 14.8231 18.3034 14.8837 18.2527C14.9443 18.202 15.018 18.1693 15.0962 18.1585L17.7266 17.7772L18.9031 15.4014C18.9383 15.3307 18.9925 15.2711 19.0597 15.2295C19.1269 15.1879 19.2043 15.1658 19.2833 15.1658C19.3624 15.1658 19.4398 15.1879 19.507 15.2295C19.5742 15.2711 19.6284 15.3307 19.6636 15.4014L20.8401 17.7772L23.4704 18.1585C23.5485 18.1697 23.6218 18.2026 23.6822 18.2533C23.7425 18.3041 23.7875 18.3707 23.8119 18.4456C23.8364 18.5206 23.8394 18.6009 23.8206 18.6775C23.8018 18.754 23.7619 18.8238 23.7055 18.8789L21.8021 20.7282L22.2506 23.339C22.264 23.4169 22.2554 23.4969 22.2256 23.5701C22.1959 23.6433 22.1462 23.7067 22.0822 23.7531C22.0183 23.7994 21.9426 23.8269 21.8637 23.8325C21.7849 23.838 21.7061 23.8213 21.6363 23.7843L19.2833 22.5514Z"
        stroke={`url(#${gradientId})`}
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="3.25"
          y1="4.33301"
          x2="22.7221"
          y2="24.8858"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={startColor} />
          <stop offset="1" stopColor={endColor} />
        </linearGradient>
      </defs>
    </svg>
  );
}
